<template>
  <div class="noWrap">
    {{ weightConvert }}
  </div>
</template>

<script>

export default {
  name: 'DataTableWeightRow',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    options: {
      type: Object,
      default() {
        return {
          sufix: ' kg',
        };
      },
    },
  },
  computed: {
    weightConvert() {
      const weight = this.value.toFixed(2).split('.');
      weight[0] = weight[0].split(/(?=(?:...)*$)/).join('.');
      return weight.join(',').concat(this.options.sufix);
    },
  },
};
</script>
